export { default as BankCard } from './bank-card-2-line-finance.svg';
export { default as Bill } from './bill-line-document.svg';
export { default as LogoutCircle } from './logout-circle-line-system.svg';
export { default as UserSuitCase } from './map-suitcase-line.svg';
export { default as UserStar } from './user-star-line-user.svg';
export { default as UserHeader } from './user-user-3-line.svg';
